/* eslint-disable max-lines */
/* eslint-disable react/jsx-one-expression-per-line */
import React from "react";
import _ from "lodash";
import { Document, Text, View, Page } from "@react-pdf/renderer";

import { styles } from "./styles";
import { Header } from "./components/Header";
import { CustomerSignature } from "./components/CustomerSignature";
import { Logo } from "./components/Logo";
import { OrderInfo } from "./components/OrderInfo";
import { OrderFinalization } from "./components/OrderFinalization";
import { PaymentInfo } from "./components/PaymentInfo";
import { ProductLineItems } from "./components/ProductLineItems";

export const OrderConfirmationPDF = ({ order, totalPrice }) => (
  <Document>
    <Page size="a4" style={styles.body}>
      <Logo />
      <Header order={order} />
      <OrderInfo order={order} />
      <ProductLineItems
        order={order}
        products={_.compact(_.flatten(order.products))}
      />

      <View wrap={false}>
        <OrderFinalization order={order} totalPrice={totalPrice} />
        <PaymentInfo order={order} />
        <CustomerSignature order={order} country={order.customer.country} />
      </View>

      <Text
        style={styles.pageNumber}
        render={({ pageNumber, totalPages }) =>
          `Seite ${pageNumber} / ${totalPages}`
        }
        fixed
      />
    </Page>
  </Document>
);
